import { render } from "./ManagementView.vue?vue&type=template&id=6e94825b&ts=true"
import script from "./ManagementView.vue?vue&type=script&lang=ts"
export * from "./ManagementView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__